<template>
    <div class="row mt-4">
        <div class="col-md-6">

            <h2>You account info e.g Name, Prefered Supermarket/Store appear here.</h2>

        </div>
    </div>
</template>

<script>
export default {
    name: 'Profile',
}
</script>